/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Main } from '../AdminTeamCreation/styles';
import AboutChallengePopup from './AboutChallengePopup';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { getActivityChallengeById } from '../../redux/actions';
import _ from 'lodash';
import Waiting from '../Waiting';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { GetSuperAdminChallengeLibraryByType, GetAdminChallengeLibraryByType, DeleteSuperAdminChallengeLibrary } from '../../redux/constants/apiConstants';
// import { ChallengeHeading } from "../CreateEvent/style";
// import { ToolTip } from "../AdminTeamCreation/styles";
// import HoverButton from '../common/HoverButtonV2';
// import { BackIcon, CreateChallenge } from '../../utils/icons';
import {CategoryWrapper, CategoryCard} from './styles';
import Thumbnail from './../Thumbnail';
import { ImageUrl } from "../../utils/constants";
import {AdminLeftArrowIcon, /*AddIconBranding,*/ LaunchIcon } from "../../utils/icons";
import { Popover } from "react-bootstrap";
import DeletePopup from '../ChallengeDetailsV2/challengeLeavePopup';
import parse from 'react-html-parser';
import {Heading} from '../RecogntionAdmin/corevalues/styles'
import { ManagerIconContainer } from "../Manager/styles";
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { VerticalDotsIcon } from '../../utils/icons';
import { DownAngleV2 } from '../SocialFeedsV2/styles';

class ChallengesChallengeLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAboutPopup: false,
      onHover: -1,
      showDeletePopup: false,
      deleteId: null,
      challengesByType: null,
    };
  }

  getTypeIdFromPath = () => {
    const { history } = this.props;
    const parts = history.location.pathname.split('/');
    return parts[parts.length - 1] || parts[parts.length - 2];
  };

  componentDidMount() {
    this.fetchChallengesByType();
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.fetchChallengesByType();
    }
  }

  fetchChallengesByType = async () => {
    const { allRoles, companyId } = this.props;
    const isSuperAdmin = allRoles?.some((r) => r.rid === 3);
    const typeId = this.getTypeIdFromPath();
    try {
      const url = isSuperAdmin
        ? `${GetSuperAdminChallengeLibraryByType}/${typeId}?company_id=${companyId || 1}&language_id=1`
        : `${GetAdminChallengeLibraryByType}/${typeId}`;
      const res = await fetchApi(url, 'GET');
      if (res.statusCode === 200) {
        this.setState({ challengesByType: res.data || [] });
      } else {
        toast.error(res.message);
        this.setState({ challengesByType: [] });
      }
    } catch(error) {
      toast.error(error.message);
      this.setState({ challengesByType: [] });
    }
  };

  redirection = () => {
    const { history } = this.props;
    history.push('/company/challenges/create-activty')
  };

  showPastEvents = (path) => {
    this.props.history.push(path);
  };

  onEnterMouse = (id) => {
    this.setState({
      onHover: id
    })
  };

  onLeaveMouse = () => {
    this.setState({
      onHover: -1
    })
  };

  showAboutChallengePopup = (id) => {
    this.props.getChallengeDetails(id).then(()=>{this.setState({
      showAboutPopup: true
    })});
  };

  hideAboutChallengePopup = () => {
    this.setState({
      showAboutPopup: false
    })
  };

  showDeletePouup = (id) => {
    this.setState({ showDeletePopup: true, deleteId: id });
  };

  hideDeletePouup = () => {
    this.setState({ showDeletePopup: false });
  };

  deleteLibraryData = async () => {
    const { deleteId } = this.state;
    this.setState({ showDeletePopup: false });
    try {
      const res = await fetchApi(`${DeleteSuperAdminChallengeLibrary}/${deleteId}`, 'DELETE');
      if (res.statusCode === 200) {
        this.setState((prev) => ({
          challengesByType: (prev.challengesByType || []).filter((c) => c.id !== deleteId),
        }));
        toast.success(res.message || 'Challenge deleted successfully');
      } else {
        toast.error(res.message);
      }
    } catch(error) {
      toast.error(error.message);
    }
  };

  popover = (text) => (
    <Popover id="popover-basic"
      style={{
        width: "100%",
        padding: "9px 14px",
        background: "#FFFFFF",
        border: "1px solid #002F47",
        boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
        borderRadius: "6px",
        zIndex:"400"
      }}  
    >
      <div  style={{
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "20px",
        color: "#002F47",
        textAlign: "center",
        zIndex:"400"
      }}>{parse(text)}
      </div>
    </Popover> );

  renderHeading = (name) => (
    <Heading color={"#184A61"}>
      <div className="close-icon" onClick={this.props.history.location.pathname.includes("/company/challenges/categories")?() => this.props.history.push('/company/challenges/categories'):() => this.props.history.push('/challenges/categories')}>
        <ManagerIconContainer isWidth={"34px"}>{AdminLeftArrowIcon('#F37A65')}</ManagerIconContainer> 
      </div>
      {name} 
      {/*<div className='end-card'>

        {this.props.role=="ADMIN"&&<ToolTip
          margin={"auto 15px auto auto"}
          activeValue={"transparent"}
          height="40px"
          width="55px"
        >
          <HoverButton
            title={this.props.t("Create Challenge")}
            width="16px"
            height="16px"
            svgPath={<AddIconBranding/>}
            onClick={this.props.history.location.pathname.includes("/company/challenges/categories")?() => this.props.history.push('/company/challenges/create-activty'):() => this.props.history.push('/challenges/create-activty') }
            activeColor={"#F37A65"}
            inActiveColor={"#F37A65"}
            backgroundColor={"white"}
            backgroundColorActive={"#F37A65"}
          />
        </ToolTip>}
      </div>*/}
    </Heading>
  );

  render() {
    const { challengeDetails, userName, history, role, t } = this.props;
    const { showAboutPopup, onHover, showDeletePopup, deleteId, challengesByType } = this.state;
    if (_.isNull(challengesByType) || _.isUndefined(challengesByType)) {
      return <Waiting />;
    }
    const challengeName = history.location.state?.categoryName || '';

    return (
      <Layout>
        <Main>
          {this.renderHeading(challengeName)}
          <CategoryWrapper>
            {challengesByType && challengesByType.length ? challengesByType.map((category, index) => (
              <CategoryCard key={index} background={"#DA6C74"} color="#FEFEFE" margin={(index+1)%3===0?"0 0px 25px 0":"0 25px 25px 0"}>
                <div className="image" onMouseEnter={() => this.onEnterMouse(category.id)} onMouseLeave={() => this.onLeaveMouse()}>
                  <Thumbnail
                    src={ImageUrl +"/"+category.image}
                    alt={"recommended card"}
                    height={"250px"}
                  />
                  {onHover === category.id &&
                    <div className='imageBackground'>
                      <div className="viewMore"  onClick={history.location.pathname.includes("/company/challenges/")?() => history.push(`/company/challenges/activity-launch/${category?.id}`):() => history.push(`/challenges/activity-launch/${category?.id}`)}>{
                        LaunchIcon()} {t("Launch Challenge")}
                      </div>
                    </div>
                  }
                </div>
                <div className='wrapperMain'>
                  <div className="categoryNameWrapper" >
                    <div className="challenge-title" style={{width:'auto', flexGrow:'4'}}>
                      {t(category.title)}<br/>
                      <p style={{fontSize:'16px', margin:'8px 0 0 0', fontWeight:'normal'}}>{t(category.month_name)}</p> 
                    </div>
                  
                    {role=="ADMIN" && (
                      <div className='adminCards' style={{width:'auto', flexGrow:'1', display:'block',padding:'16px'}}>
                        <DownAngleV2 feed>
                          <DropdownButton 
                            id={`dropdown-${category.id}`} 
                            title={<VerticalDotsIcon/>}
                            align="end"
                          >
                            <Dropdown.Item 
                              onClick={history.location.pathname.includes("/company/challenges/categories/")?() => history.push(`/company/challenges/activity-edit/${category.id}`):() => history.push(`/challenges/activity-edit/${category.id}`)}
                            >
                              {t("Edit")}
                            </Dropdown.Item>
                            <Dropdown.Item 
                              onClick={() => this.showDeletePouup(category.id)}
                            >
                              {t("Delete")}
                            </Dropdown.Item>
                          </DropdownButton>
                        </DownAngleV2>
                      </div>
                    )}
                  </div>
                </div>
              </CategoryCard>)): null}
          </CategoryWrapper>
          {showAboutPopup && (
            <AboutChallengePopup 
              show={showAboutPopup} 
              challengeData={challengeDetails} 
              userName={userName} 
              hideAboutChallengePopup={this.hideAboutChallengePopup} 
              history={history}
            />
          )}
          {showDeletePopup && (
            <DeletePopup
              deleteId={deleteId}
              showConfirmPopupDelete={showDeletePopup}
              showHideDeletePopup={this.hideDeletePouup}
              deleteData={this.deleteLibraryData}
              popupTitle={t("Delete Challenge")}
              popupHeading={t("Are you sure you want to delete this Challenge?")}
              showDeleteLibrary={true}
            />
          )}
        </Main>
      </Layout>
    );
  }
}

ChallengesChallengeLibrary.propTypes = {
  history: PropTypes.object,
  role: PropTypes.string,
  getChallengeDetails: PropTypes.func,
  challengeDetails: PropTypes.array,
  userName: PropTypes.string,
  allRoles: PropTypes.array,
  companyId: PropTypes.number,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  challengeDetails: state.challenges.activityDetailsById,
  userName: state.profileData.firstName,
  allRoles: state.profileData.allRoles,
  companyId: state.profileData.companyDetails?.id,
})

const mapDispatchToProps = (dispatch) => ({
  getChallengeDetails: (id) => dispatch(getActivityChallengeById(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChallengesChallengeLibrary));